import React, { createElement, useEffect } from "react";
import { createMuiTheme, ThemeProvider } from "@material-ui/core/styles";
import {
  makeStyles,
  Typography,
  Box,
  Container,
  useTheme,
  Grid,
  useMediaQuery,
} from "@material-ui/core";

export default function BrandStory() {
  const theme = createMuiTheme({
    palette: {
      primary: {
        main: "#103775",
      },
      secondary: {
        main: "#C67500",
        light: "#E1B663",
      },
    },
    typography: {
      body1: {
        lineHeight: "2",
        fontSize: "1rem",
      },
    },
  });
  const isPhone = useMediaQuery("(max-width:576px)");
  useEffect(() => {
    window.scrollTo({
      top: isPhone ? 0 : 750,
      behavior: "smooth",
    });
  }, [isPhone]);
  return (
    <div>
      <ThemeProvider theme={theme}>
        <TitleImg />
        <BrandContent />
      </ThemeProvider>
    </div>
  );
}

//ANCHOR 開頭圖片
function TitleImg() {
  const isPhone = useMediaQuery("(max-width:576px)");
  const isSmPhone = useMediaQuery("(max-width:576px)");
  const isTable = useMediaQuery("(max-width:960px)");
  const isTablet = useMediaQuery("(max-width:1025px)");
  const useStyles = makeStyles((theme) => ({
    img: {
      width: "100%",
      height: isPhone ? "60vh" : "100vh",
      objectFit: "cover",
    },
    textBox: {
      position: "absolute",
      top: "50%",
      left: "50%",
      width: "100%",
      transform: "translate( -50%, -50%)",
      display: "flex",
      justifyContent: "center",
      flexDirection: "column",
      alignItems: "center",
    },
  }));
  const classes = useStyles();

  return (
    <Box position="relative">
      <img src="/assets/images/Home/new2.png" className={classes.img} />
      <Container maxWidth="xl">
        <Box className={classes.textBox}>
          <Typography
            variant={isSmPhone ? "body1" : "h5"}
            style={{ color: "#fff", fontWeight: "bold" }}
          >
            FULLHOUSE FORECLOSURE
          </Typography>
          <Typography variant="h6" style={{ color: "#fff" }}>
            品牌故事
          </Typography>
        </Box>
      </Container>
    </Box>
  );
}

function Light({ children }) {
  const theme = useTheme();
  return (
    <span style={{ color: theme.palette.secondary.light }}> {children} </span>
  );
}
function BrandContent() {
  const theme = useTheme();
  const useStyles = makeStyles((theme) => ({
    brandContent: {
      "& .MuiTypography-body1": {
        lineHeight: "3" + " !important",
      },
    },
    ulList: {
      listStyleType: "trad-chinese-informal",
    },
  }));
  const classes = useStyles();

  const ulList = [
    {
      list: "法拍屋資訊提供",
    },
    {
      list: "代墊法拍屋價金",
    },
    {
      list: "拍賣不動產節稅",
    },
    {
      list: "不動產強制執行",
    },
    {
      list: "法拍屋撤封轉貸",
    },
    {
      list: "辦理銀行貸款",
      caption: "(代墊)",
    },
    {
      list: "法拍屋代理標購",
      caption: "(代標)",
    },
    {
      list: "法拍屋代理專業點交",
      caption: "(代點)",
    },
    {
      list: "辦理法拍屋拍賣後退稅款",
    },
    {
      list: "辦理拍賣、買賣案件過戶",
    },
    {
      list: "法拍屋各項拍賣法律諮詢",
    },
    {
      list: "數位影像房屋系統資訊提供",
    },
    {
      list: "銀行代墊法拍屋尾款低利墊款",
    },
    {
      list: "代理債務人、承租人法拍屋專業交屋",
      caption: "(代交)",
    },
    {
      list: "各種拍賣屋、房地產等房訊、刊物與專業叢書出版",
    },
    {
      list: "拍賣屋法規研究、實務教學、專業講習課程與諮詢服務",
    },
  ];

  const fullLyrics = [
    {
      section: [
        "真誠服務是天職",
        "工作愉快又充實",
        "充滿自信的面對痛苦",
        "成功　是注定的事。",
      ],
    },
    {
      section: [
        "堅持本業又負責",
        "幻想空想多費時",
        "康莊之路　大步地向前走",
        "人生總要努力過",
      ],
    },
    {
      section: ["不管庸才或天才", "總要努力百分百", "歡樂人生相隨伴我新開懷"],
    },
    {
      section: ["富貴之屋永同在", "＊富貴之屋　永～同～在～"],
    },
  ];

  const fullQuotations = [
    {
      list: [
        "富屋語錄 ( 一) 經營理念篇 富屋語錄 ( 二) 大鵬展翅篇 富屋語錄 ( 三) 轟天大法篇",
        "富屋語錄 ( 四) 心靈雞湯篇 富屋語錄 ( 五) 團結一條心篇 富屋語錄 ( 六) 任我行一定強篇",
        "富屋語錄 ( 七) 熱心如火篇 富屋語錄 ( 八) 無上心法篇 富屋語錄 ( 九) 激勵鼓舞篇",
        "富屋語錄 ( 十) 我的本錢篇 富屋語錄 ( 十一) 泥土中的金沙篇 富屋語錄 ( 十二) 追求卓越篇",
        "富屋語錄 ( 十三) 動起來篇 富屋語錄 ( 十四) 樂觀進取篇 富屋語錄 ( 十五) 成功定律篇",
        "富屋語錄 ( 十六) 取巧代價篇 富屋語錄 ( 十七) 堅持方向篇 富屋語錄 ( 十八) 馬上行動篇",
        "富屋語錄 ( 十九) 光明正道篇 富屋語錄 ( 二十) 頓悟篇 富屋語錄 ( 二一) 成功第一步篇",
        "富屋語錄 ( 二二) 優勢品牌篇",
        "富屋語錄 ( 二三) 聰明理財篇 【68句箴言】:",
      ],
    },
    {
      list: [
        "理財工具何其多 誤投破財到處有 一塊玩十如期貨 反轉而下就斷頭",
        "百萬股民敢死隊 積蓄何嘆空有過 虛報假帳真受夠 惡意掏空睡橋頭",
        "露宿參風誰人理 投資錯誤莫怨尤 預售房屋大風險 多付可換幾台車",
        "公園可能變草原 泳池也許變水溝 蓋的起來哪知否 建商倒閉是常有",
        "市售房屋沒利頭 一屋二賣倒楣透 辛苦努力大半輩 一生積蓄化烏有",
        "假買事件也很多 銀行放貸錢已偷 價金給付想反悔 房屋早就查封過",
        "多少經驗早告知 富人房屋總特多 理財工具慎選擇 還是法拍價值優",
        "買後十年少奮鬥 十萬賺到十億多 產權清楚多好貨 悄悄賺進多少樓",
        "銳利眼光早洞悉 誰說便宜沒好貨 自住投資兩相宜 共創四贏慶歡樂",
        "有點事項要提醒 惜因牽涉法令多 涉及程序亦繁雜 專業水準可要夠",
        "市面不肖業者多 短視近利嘆搖頭 低價承接再作假 羊入虎口狼眷窩",
        "箇中原因非兩句 奉勸選擇品牌優 專研深究無間斷 法令變化常進修",
        "專業解析能力夠 交屋合法才安樂 自行投標非專業 五樓可能變一樓",
        "產權分析無透徹 多賦稅費可買樓 點交專業無精通 浪費金錢多口舌",
        "誤造糾紛何其多 還是無法如願由 專業何等重要性 餘億反成負債愁",
        "三言兩語道不盡 只怪專業沒委託 專業取向分工制 運用智慧經驗多",
        "託付專業高智慧 程序倒背也如流 和諧合法來交屋 醒來黃金片滿樓",
      ],
    },
    {
      list: [
        "富屋語錄 ( 二四) 景氣與爭氣篇 富屋語錄 ( 二五) 成功得標篇 富屋語錄 ( 二六) 行銷策略篇",
        "富屋語錄 ( 二七) 法拍屬性篇",
        "富屋語錄 ( 二八) 房仲與法拍業之誠信原則篇 富屋語錄 ( 二九) 創新篇 富屋語錄 ( 三十) 趨勢品牌篇",
        "富屋語錄 ( 三一) 鑽石光芒篇 富屋語錄 ( 三二) 遊魂型之軟骨功篇 富屋語錄 ( 三三) 真正經篇",
      ],
    },
  ];

  const cisList = [
    {
      img: "/assets/images/BrandStory/state1.png",
      message:
        "富屋產業集團CIS標誌是民國76年（1987年）於富屋汽車旅館及民國77年（1988年10月）富屋法拍屋成立之際，為了創立企業形象與精神繪製而成；其意為「旭日源源不熄，邁向富貴之門」。象徵富屋人【有朝氣、有活力、光明正氣、有衝勁】，堅持富屋三大原則五大信念者必將邁入富貴康莊大道。",
    },
    {
      img: "/assets/images/BrandStory/state2.png",
      message:
        "民國100年（2011年），企業規模迅速擴展，已為法拍業界領導品牌，加盟店達100家以上；其意為『藍天、綠地、人的融合』做為企業CIS標誌。",
    },
    {
      img: "/assets/images/BrandStory/state3.png",
      message:
        "民國108年（2019年），富屋企業集團及所屬控股公司集團，自有資產及加盟店均已遍及全台各地，更成為法拍業界龍頭品牌，並逐步拓展至全球各地成為跨國企業；其意為『逆轉人生、無限可能』做為企業CIS標誌。",
    },
  ];

  return (
    <div className={classes.brandContent}>
      <Container maxWidth="lg">
        <Box py={8}>
          {/* ANCHOR 關於富屋 */}
          <>
            <Box my={4}>
              <Title title="關於富屋" />
            </Box>
            <Box>
              <Typography variant="body1">
                富屋企業集團以
                <Light>
                  【 正派經營、誠信服務、光明正氣、專業負責、永續經營 】
                </Light>
                為最高經營指導方針。
                <br />
                富屋企業集團
                <Light>FUMAN ENTERPRISE GROUP</Light>
              </Typography>
            </Box>
          </>

          {/* ANCHOR 相關企業與精神 */}
          <>
            <Box my={4}>
              <Title title="相關企業與精神" />
            </Box>
            <Box my={4}>
              <Typography variant="body1">
                富屋相關企業立足中台灣地區至今已經二十餘年，早期由旅館業發跡，民國八十年初，富屋體系直營旅館與汽車旅館達八家，至民國八十三年起看準法拍市場所具的投資潛力，進而逐步轉型推展至法拍市場等相關產業，在台灣地區歷史悠久、基礎穩固、口碑良好。富屋法拍屋集團創立於1988年，為全球歷史最久法拍加盟連鎖鼻祖。
                <br />
                2018年法拍事業版圖已擴展至中國大陸，並於2021年成功擴展至新加波、馬來西亞等海外全球市場，為全球化世界性法拍屋龍頭品牌。
                <br />
                經營研究團隊並持續不斷的深耕及深研各項法拍實務與專業，以立於法拍權威之不墜，更秉持著
                <Light>『富屋先生』</Light>
                良好的文化傳承，以其嚴謹專業的態度誠信服務客戶，讓每一位由富屋先生所服務過的客戶都能從此邁向富貴之門；公司內、外電腦作業系統歷經多年來數百次更新改版，已逐步朝向全面電腦化管理，目前更加速e化與M化將法拍等相關產業擴展市場規模集團化；長期目標公開發行股票成立上市公司並進軍產業全球化。
              </Typography>
            </Box>

            <Box my={4}>
              <Typography variant="body1">
                {" "}
                「一夕致富-法拍屋‧金拍屋‧銀拍屋」，2004年出版。{" "}
              </Typography>
              <Typography variant="body1">
                {" "}
                「從十萬賺到十億-法拍屋‧金拍屋‧銀拍屋“貸款、稅費”實用技巧」，2005年出版。{" "}
              </Typography>
              <Typography variant="body1">
                {" "}
                「法拍權威教您購屋致富」，2005年出版。...等一百多本以上專業書籍出版。{" "}
              </Typography>
            </Box>
          </>
          {/* ANCHOR 黃建融 所長 */}
          <>
            <Box my={4}>
              <Title title="黃建融 所長" />
            </Box>
            <Box my={4}>
              <Typography variant="body1">
                從事於不動產相關事業及法拍業務已十餘年，期間通過『地政士』與『不動產經紀人』國家考試及格，東海大學地政班結業及東海大學強制執行法律研究班，發表文章散見於報章雜誌
                ，並著作出版『不動產法拍專業等多本叢書』，畢生致力於不動產等拍賣業務之研究；夫人則在法院從事於公職，大學畢業後通過『地政士』、『不動產經紀人』與『司法特考』等國家考試及格，東海大學地政班結業、東海大學稅務班結業，並著有多本專業書籍出版。
              </Typography>

              <Typography variant="body1">
                『代書』、『不動產經紀人』雙證照國家考試及格，數十年專一深研法拍專業與實務；著作：『一夕致富─法拍屋、
                等一百多本以上專業法拍系列致富叢書！全國第一位建請內政部而做出函釋『代標』規範之法拍實務業界；
                ( 內政部89‧12‧26台 ( 89)
                內中第字第8980474號參照)造福國內眾多法拍代標業者與購屋者，有效提升不動產交易品質並保障消費者權益。
              </Typography>
            </Box>

            <Box my={4}>
              <Typography variant="body1">
                全國第一位建請內政部而做出函釋『點交』規範之法拍實務業界； (
                內政部91‧2‧18台 ( 91)
                內中第字第0910083161號參照)造福國內眾多法拍代標業者、法拍點交業者、購屋者、原屋主，有效提升不動產交易品質，使其更符合公平正義，並保障消費者、原屋主與承租人權益。
              </Typography>

              <Typography variant="body1">
                造福國內眾多法拍代標業者、法拍點交業者、購屋者、原屋主，有效提升不動產交易品質，使其更符合公平正義，並保障消費者、原屋主與承租人權益。
              </Typography>
              <Typography variant="body1">
                全國第一本完整介紹法拍、金拍、銀拍系列叢書之法拍實務業界；『一夕致富-法拍屋、金拍屋、銀拍屋』
                ( 93‧7‧31出版)
              </Typography>
              <Typography variant="body1">
                擁有超過100多本以上各種專業叢書、教育訓練書籍與專業教育訓練教室！
              </Typography>
            </Box>

            <Box my={4}>
              <Typography vatiant="body1">
                ◎95年11月開放創業加盟店申請，由於申請者眾多，後經公司嚴格審核，開放當月即有八家通過考核成為加盟店。
              </Typography>
              <Typography vatiant="body1">
                ◎96年3月富屋加盟店成長至19家。
              </Typography>
              <Typography vatiant="body1">
                現代的世紀是科技化的世紀，本公司不僅累積著相當豐富經驗的傳承，更以追求卓越，堅持品質第一為唯一目標。在豐富的專業知識與專一深研法拍事務的堅強團隊陣容組織下，再配合著電腦網路科技與全面電腦化的內部管理系統，將拍賣屋的各項作業與流程及其效率在合法、和諧的狀態下加以速度化與精緻化！
              </Typography>

              <Typography variant="body1">
                而本公司亦只針對法拍屋標購、專業點交，各銀行之代墊低利率貸款之專一法拍事務，並不兼營其他營業事項，有別其他公司兼營各項事務，有如雜貨店般，而各項事務亦因所遷涉的專業與繁雜的法令交錯，並且在似懂非懂的情況下均無法到達專精，真正有效的保障客戶及其交易的安全性。所以本公司嚴守專一性與專業分工之原則，在專一深研的法拍事務制度下，於法拍屋標購、專業責任點交均遠遠凌駕其他業者，為客戶有更深一層的品質專業保障。
              </Typography>

              {/* ul list */}
              <ul className={classes.ulList}>
                {ulList.map((item) => {
                  return (
                    <li>
                      <Typography variant="body1">
                        {item.list}
                        <Light>{item.caption ? item.caption : ""}</Light>
                      </Typography>
                    </li>
                  );
                })}
              </ul>

              {/* 法拍權威 */}
              <Box
                my={2}
                px={2}
                py={4}
                style={{
                  backgroundColor: theme.palette.primary.main,
                  borderRadius: "10px",
                }}
                color="#fff"
              >
                <Box my={2}>
                  <Typography variant="h5" style={{ fontWeight: "bold" }}>
                    堅持品質專業、全國法拍權威
                  </Typography>
                </Box>
                <Box>
                  <Typography variant="body1">
                    您因為投資、結婚、搬家、換工作、租不如買…等原因而欲尋找您心目中理想的房屋或土地，卻不知從何處找起？如何才能找到物超所值又適合自己個性風格的優良住所？如何才能節省各項稅費？如何才能買的安心住的放心？如何才能投資房地產致富？如何選擇優良法拍業者？…您購屋的各種疑點和困擾，都是富屋數位房訊的專業與責任！擁有法政碩士、律師、土地代書、不動產經紀人…等堅強法拍顧問團隊陣容，以堅持服務品質第一、專業能力第一、快速合法第一、點交效率第一、客戶權益第一的富屋企業優良傳統，在中部地區已經是成立二十餘年的知名優良品牌，是您標購法拍屋最強大的靠山！
                  </Typography>
                </Box>
              </Box>
              {/* 理財工具.. */}
              <Box
                my={2}
                px={2}
                py={4}
                style={{
                  backgroundColor: theme.palette.primary.main,
                  borderRadius: "10px",
                }}
                color="#fff"
              >
                <Box my={2}>
                  <Typography variant="h5" style={{ fontWeight: "bold" }}>
                    標購法拍屋已經成為最熱門的全民投資理財工具
                  </Typography>
                </Box>
                <Box>
                  <Typography variant="body1">
                    根據內政部地政司93年第一季統計資料顯示，全國每8名（台中、台南地區每3.8人）購屋者中即有1人是標購法拍屋，標購法拍屋已經是全民投資運動，根據統計，每年法拍市場拍定金額大於新台幣2180億規模，投資法拍屋賺大錢與圓屋夢的人比比皆是，您再不把握機會投入法拍屋市場是否太落伍了呢？
                    <br />
                    另外根據消費者文教基金會近年來統計結果指出，在所有的買賣糾紛中以房屋買賣所產生的購屋糾紛排名第一。因此，慎選優良法拍業者是您標購法拍屋最重要的一件事！您如將標購法拍屋交由擁有堅強法拍團隊與熟悉拍賣程序流程與相關法令的富屋專業法拍來替您服務
                    ( 十餘年來客戶交易零糾紛)
                    ，您會發現標購法拍屋是件輕鬆又快樂的事，完全沒煩惱！
                  </Typography>
                </Box>
              </Box>
            </Box>
          </>
          {/* ANCHOR 富屋先生 */}
          <Grid container>
            <Grid xs={12} md={6} item>
              <Box>
                <Box my={4}>
                  <Title title="富屋先生" />
                </Box>
                <Box my={2}>
                  <Typography variant="h6" style={{ fontWeight: "bold" }}>
                    富屋先生-代表企業傳承
                  </Typography>
                </Box>

                <Box mt={2} pb={6}>
                  <Typography variant="body1" style={{ textIndent: "1.5em" }}>
                    標購法拍屋、金拍屋等拍賣房屋，不僅要選擇其專業、經驗與學習各項法令吸取新知的態度，更要注重其品牌、形象、團隊及誠信的重視與堅持！在職的每一位富屋人對外都代表著
                    <Light>「富屋先生」</Light>。
                  </Typography>
                  <Typography variant="body1" style={{ textIndent: "1.5em" }}>
                    富屋先生秉持了富屋優良傳統精神
                    <Light>『有朝氣、有活力、光明正氣、有衝勁』</Light>
                    ，對事本著專業負責的態度、以客為尊、服務至上，任何房屋的事交給富屋先生來做，既專業又快速更安心，讓每一位由富屋先生所服務過的客戶都能從此邁向富貴之門；一通電話服務到家，亦真正讓客戶感受到
                    <Light>「足不出戶一切搞定」</Light>的確實目標。
                  </Typography>
                  <Typography variant="body1">
                    傳奇人物：延續富屋優良傳統精神再造富屋先生
                  </Typography>
                  <Typography variant="body1">
                    富屋先生特色：
                    <Light>
                      『學識淵博、頭腦靈活、服務親切、專業足夠，房屋的事交給富屋先生真不錯！』
                    </Light>
                  </Typography>
                </Box>

                <Box>
                  <Typography variant="body1">
                    富屋吉祥動物：<Light>『活力豹』</Light>
                    代表富屋人特有的行動力
                  </Typography>
                </Box>
              </Box>
            </Grid>
            {/* 吉祥物svg  豹 */}
            <Grid item xs={12} md={6}>
              <Box>
                <img src={"/assets/images/BrandStory/LogoLeopard.png"} />
              </Box>
            </Grid>
          </Grid>
          {/* ANCHOR 富屋之歌 */}
          <>
            <Box my={4}>
              <Title title="富屋之歌" />
            </Box>
            <Box my={2}>
              <Box mb={4}>
                <Typography variant="body1">
                  {`富屋之歌 ( 樂在工作） 詞：黃建融 ∕ 曲：黃建融`}
                </Typography>
              </Box>
              {fullLyrics.map((item) => {
                return (
                  <Box mb={2}>
                    {item.section.map((item) => {
                      return <Typography variant="body1">{item}</Typography>;
                    })}
                  </Box>
                );
              })}
            </Box>
          </>
          {/* ANCHOR 富屋語錄 */}
          <>
            <Box my={4}>
              <Title title="富屋語錄" />
            </Box>

            <Box my={2}>
              <Typography variant="body1" style={{ textIndent: "1.5em" }}>
                語錄是方法與技巧、智慧的結晶，是經驗的延續，刻劃了無數歲月的痕跡，有成長的腳步與前人的努力，最重要的意義是減低錯誤的發生機率，邁向成功之門。雖然{" "}
                <Light>『成功沒有捷徑，但有一定的方法可尋』</Light>{" "}
                ，不管從前來自社會各個階層，每一個同仁{" "}
                <Light>『在富屋的心境，一切均從歸零開始出發』</Light>{" "}
                ，伴隨著公司的腳步，<Light>《腳踏實地、按步就班》</Light>
                負責任的態度完成每一件事，因為
                <Light>『我們深信只要對的事就要堅持去做好』</Light>
                ，只要努力一切以平常心來面對，成功即將在眼前。
              </Typography>
            </Box>

            <Box mt={2} mb={6}>
              <Typography variant="body1">
                活力朝氣裡面做 毫無衝勁不適合 熱門行業有甜頭
              </Typography>
              <Typography variant="body1">
                方法就是常聯絡 說話專業能力夠 想不賺錢也難得
              </Typography>
              <Typography variant="body1">
                各行各業苦哈哈 公司訓練能配合
              </Typography>
            </Box>
            {fullQuotations.map((item, index) => {
              return (
                <Box my={index == 1 ? 6 : 2}>
                  {item.list.map((item) => {
                    return <Typography variant="body1">{item}</Typography>;
                  })}
                </Box>
              );
            })}
          </>
          {/* ANCHOR 富屋企業識別CIS */}

          <Box my={4}>
            <Box mt={2} mb={6}>
              <Title title="富屋企業識別CIS" />
            </Box>
            <Grid container spacing={4} alignItems="center">
              {cisList.map((item) => {
                return (
                  <>
                    <Grid item container justify="center" xs={12} md={2}>
                      <img
                        src={item.img}
                        width="200px"
                        height="182px"
                        style={{ objectFit: "cover", borderRadius: "10px" }}
                      />
                    </Grid>
                    <Grid item xs={12} md={10}>
                      <Typography
                        variant="body1"
                        style={{ textIndent: "1.5em" }}
                      >
                        {item.message}
                      </Typography>
                    </Grid>
                  </>
                );
              })}
            </Grid>
          </Box>
        </Box>
      </Container>
    </div>
  );
}

function Title({ title }) {
  return (
    <Typography variant="h4" color="primary" style={{ fontWeight: "bold" }}>
      {title}
    </Typography>
  );
}
